<template>
    <div>
        <div class="content-box first">
            <RsStep class="full" :active="1" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <div v-loading="pageLoading" element-loading-text="合同获取中...">
                <div class="contract-box">
                    <div class="url-box">
                        <iframe :src="contractUrl" scrolling="no" frameborder="0"></iframe>
                    </div>
                </div>
                <div class="page-btn-box">
                    <el-button type="primary" @click="signContract">开始签署</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageLoading: false,
            contractUrl: '',
            status: 0,
            fddInfo: {},
        };
    },
    computed: {},
    created() {
        this.getContract();
    },
    methods: {
        // 签约等待
        async waitConfirm(status, url) {
            const flag = await this.$fadadaConfirm('合同签署', '请确认是否完成了合同的签署', status == 5 ? 1 : status == 1 ? 2 : status, url);
            if (flag == 'success') {
                this.$message.success('合同签署成功');
                await this.$store.dispatch('getUserInfo');
                return (window.location.href = this.$contractRouter('/manage/contract/verify/fdd/step/3', 'url'));
            }
            if (flag == 'refresh') return this.getContract();
        },
        // 获取合同信息
        async getContract() {
            this.pageLoading = true;
            const response = await this.$request.post('/fabigbig/viewContract', {}, {formData: false});
            this.pageLoading = false;
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '合同载入失败');
            const {contractFileFullPath, fddSignStatus, fddSignUrl} = result;
            this.contractUrl = contractFileFullPath;
            this.fddInfo = result;
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            this.waitConfirm(fddSignStatus, fddSignUrl);
        },
        // 签署个人合同
        async signContract() {
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            const response = await this.$request.post('/fabigbig/view/sign', {}, {formData: false});
            const {state, msg, result} = response.data;
            if (!state) return this.$message.error(msg || '抱歉，调用签署失败');
            const flag = await this.$msgbox({
                title: '前往电子合同平台“法大大”',
                message: '即将前往电子合同平台“法大大”，在该平台，你将，完成电子合同的签署。',
                confirmButtonText: '确认前往',
            });
            if (flag === 'cancel') return;
            window.open(result);
            this.getContract();
        },
    },
};
</script>

<style lang="scss" scoped>
.contract-box {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-x: auto;
    margin: 20px 0;

    .url-box {
        flex: 1;
        min-width: 1000px;

        iframe {
            width: 100%;
            height: 900px;
        }
    }
}

.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
